import axios from "axios";

const configuredBackendUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
// Browser API requests stay same-origin in production and are rewritten by
// Vercel. Twilio must never use that proxy: Media Streams are WebSockets and
// the callback URL must resolve directly to the Fly backend. Keep a canonical
// fixed Fly origin so a stale browser build variable cannot point Twilio back
// at the retired Railway host.
const FLY_BACKEND_URL = "https://ordrs.fly.dev";
const browserHostname = typeof window !== "undefined" ? window.location.hostname : "";
const isLocalDevelopment = ["localhost", "127.0.0.1"].includes(browserHostname);
const isVercelProductionHost = ["ordrs.ai", "www.ordrs.ai"].includes(browserHostname)
  || browserHostname.endsWith(".vercel.app");
if (isLocalDevelopment && !configuredBackendUrl) {
  // eslint-disable-next-line no-console
  console.error(
    "[ordrs] REACT_APP_BACKEND_URL is not set for local development. " +
      "Set it in frontend/.env."
  );
}
export const API = isLocalDevelopment
  ? `${configuredBackendUrl || FLY_BACKEND_URL}/api`
  : isVercelProductionHost
    ? "/api"
    : `${FLY_BACKEND_URL}/api`;
export const PUBLIC_API = `${FLY_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ordrs_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  const session = BUILD_SESSION.get();
  if (session?.capability) cfg.headers["X-Preview-Capability"] = session.capability;
  return cfg;
});

// Build-session cookie — persists the slug so returning visitors resume their build.
// 30-day expiry. No auth needed; slug is the natural identifier.
const BUILD_COOKIE = "ordrs_build";
export const BUILD_SESSION = {
  get: () => {
    const m = document.cookie.match(/(?:^|;\s*)ordrs_build=([^;]+)/);
    try { return m ? JSON.parse(decodeURIComponent(m[1])) : null; } catch { return null; }
  },
  set: (slug, name, capability) => {
    const previous = BUILD_SESSION.get();
    const val = encodeURIComponent(JSON.stringify({ slug, name, capability: capability || previous?.capability || null }));
    const exp = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${BUILD_COOKIE}=${val};path=/;expires=${exp};SameSite=Lax`;
  },
  clear: () => {
    document.cookie = `${BUILD_COOKIE}=;path=/;max-age=0;expires=Thu, 01 Jan 1970 00:00:00 GMT;SameSite=Lax`;
  },
};

export const AUTH = {
  token: () => localStorage.getItem("ordrs_token"),
  user: () => {
    const raw = localStorage.getItem("ordrs_user");
    return raw ? JSON.parse(raw) : null;
  },
  set: (token, user) => {
    localStorage.setItem("ordrs_token", token);
    localStorage.setItem("ordrs_user", JSON.stringify(user));
  },
  clear: () => {
    localStorage.removeItem("ordrs_token");
    localStorage.removeItem("ordrs_user");
  },
};
